import ContactStatus from "@/models/Contacts/ContactStatus";

export default class ContactProfileSearchRequest {
    status: ContactStatus = ContactStatus.Active;
    companyId: string = null;
    isAgreedToMarketing = true;
    locationTypeIds: string[] = [];
    positionCodes: string[] = [];
    latitude = 0;
    longitude = 0;
    distance = 0;
}